import {
  BASE_API_URL,
  post,
} from '@/utils/http'

export const queryYearList = (...args) => {
  return post(`${BASE_API_URL}/pz/common/queryYearList`, ...args).then((res) => {
    const { data } = res

    return {
      data: data.map((el) => {
        return {
          zddm: el,
          zdmc: `${el}年`,
        }
      }),
    }
  })
}

export const queryEnrollTypeUrl = `${BASE_API_URL}/zs/zd/queryXbZslbList`
export const queryEnrollType = (...args) => {
  return post(queryEnrollTypeUrl, ...args)
}

// 查询招生院校
export const queryCommonEnrollSchoolListUrl = `${BASE_API_URL}/pz/xbzd/queryZsyxZdList`
export const queryCommonEnrollSchoolList = (...args) => {
  return post(queryCommonEnrollSchoolListUrl, ...args)
}

// 查询院校
export const queryDepartmentListUrl = `${BASE_API_URL}/pz/xbzd/queryYxZdList`
export const queryDepartmentList = (...args) => {
  return post(queryDepartmentListUrl, ...args)
}

// 查询专业
export const queryMajorListUrl = `${BASE_API_URL}/pz/xbzd/queryZyZdList`
export const queryMajorList = (...args) => {
  return post(queryMajorListUrl, ...args)
}

// 查询培养层次
export const queryCultivationLevelUrl = `${BASE_API_URL}/pz/xbzd/queryPyccZdList`
export const queryCultivationLevel = (...args) => {
  return post(queryCultivationLevelUrl, ...args)
}

// 获取学制
export const queryEduYearUrl = `${BASE_API_URL}/pz/xbzd/queryXzZdList`
export const queryEduYear = (...args) => {
  return post(queryEduYearUrl, ...args)
}

export const queryUsedUrl = `${BASE_API_URL}/pz/gbzd/querySfList`
export const queryUsed = (...args) => {
  return post(queryUsedUrl, ...args)
}

// 查询校标生源地区字典列表
export const querySchoolBirthPlaceDictUrl = `${BASE_API_URL}/pz/gbzd/queryXzqhZdList`
export const querySchoolBirthPlaceDict = (...args) => {
  return post(querySchoolBirthPlaceDictUrl, ...args)
}

// 获取招生类别
export const queryEnrollCategoryUrl = `${BASE_API_URL}/pz/xbzd/queryZslbZdList`
export const queryEnrollCategory = (...args) => {
  return post(queryEnrollCategoryUrl, ...args)
}

// 获取省标体检结论字典
export const queryBodyCheckResultListUrl = `${BASE_API_URL}/pz/sbzd/queryTjjlList`
export const queryBodyCheckResultList = (...args) => {
  return post(queryBodyCheckResultListUrl, ...args)
}

// 获取国标既往病史字典
export const queryPastMedicalHistoryListUrl = `${BASE_API_URL}/pz/gbzd/queryJwbsList`
export const queryPastMedicalHistoryList = (...args) => {
  return post(queryPastMedicalHistoryListUrl, ...args)
}

// 查询国标字典
export const queryNationMajorDictUrl = `${BASE_API_URL}/pz/gbzd/queryGbzyList`
export const queryNationMajorDict = (...args) => {
  return post(queryNationMajorDictUrl, ...args)
}

// 查询国标生源类别字典
export const queryStudentDictUrl = `${BASE_API_URL}/pz/gbzd/querySylbList`
export const queryStudentDict = (...args) => {
  return post(queryStudentDictUrl, ...args)
}

// 获取证件类型
export const queryIdentityTypeUrl = `${BASE_API_URL}/zs/zd/queryGbZjlxList`
export const queryIdentityType = (...args) => {
  return post(queryIdentityTypeUrl, ...args)
}

// 获取打印模板详情
export const queryTemplateDetailUrl = `${BASE_API_URL}/gl/dymb/queryDymbDetail`
export const queryTemplateDetail = (...args) => {
  return post(queryTemplateDetailUrl, ...args)
}

// 获取批次接口
export const queryOtherTypeBatchUrl = `${BASE_API_URL}/zs/zd/queryQtZspcList`
export const queryOtherTypeBatch = (...args) => {
  return post(queryOtherTypeBatchUrl, ...args)
}

// 获取科类
export const queryCategoryListUrl = `${BASE_API_URL}/zs/zd/queryXbKlList`
export const queryCategoryList = (...args) => {
  return post(queryCategoryListUrl, ...args)
}

// 获取所属大类
export const queryBigCategoryListUrl = `${BASE_API_URL}/zs/zd/queryGbSsdlList`
export const queryBigCategoryList = (...args) => {
  return post(queryBigCategoryListUrl, ...args)
}

// 获取招生季节
export const querySeasonListUrl = `${BASE_API_URL}/zs/zd/queryGbZsjjList`
export const querySeasonList = (...args) => {
  return post(querySeasonListUrl, ...args)
}

// 富文本上传图片
export const uploadPublicReadImgUrl = `${BASE_API_URL}/dz/common/uploadDzTpFile`
export const uploadPublicReadImg = (...args) => {
  return post(uploadPublicReadImgUrl, ...args)
}

// 富文本上传文件
export const uploadPublicReadFileUrl = `${BASE_API_URL}/dz/common/uploadDzFjFile`
export const uploadPublicReadFile = (...args) => {
  return post(uploadPublicReadFileUrl, ...args)
}

export const queryOpenStatusUrl = `${BASE_API_URL}/zs/zd/queryGbSfqyList`
export const queryOpenStatus = (...args) => {
  return post(queryOpenStatusUrl, ...args)
}

export const queryUserCategoryUrl = `${BASE_API_URL}/zs/zd/queryGbYhlbList`
export const queryUserCategory = (...args) => {
  return post(queryUserCategoryUrl, ...args)
}

export const queryEnrollBatchFlowListUrl = `${BASE_API_URL}/zs/zd/queryGbPcjdList`
export const queryEnrollBatchFlowList = (...args) => {
  return post(queryEnrollBatchFlowListUrl, ...args)
}

export const querySingleEnrollCategoryListUrl = `${BASE_API_URL}/zs/zd/queryXbDzlbList`
export const querySingleEnrollCategoryList = (...args) => {
  return post(querySingleEnrollCategoryListUrl, ...args)
}

// 字段类型
export const queryFieldTypeUrl = `${BASE_API_URL}/zs/zd/queryGbSjlxList`
export const queryFieldType = (...args) => {
  return post(queryFieldTypeUrl, ...args)
}

// 附件要求
export const queryAttachmentNeedUrl = `${BASE_API_URL}/zs/zd/queryGbFjyqList`
export const queryAttachmentNeed = (...args) => {
  return post(queryAttachmentNeedUrl, ...args)
}

// 照片超片尺寸要求
export const queryPhotoPercentNeedUrl = `${BASE_API_URL}/zs/zd/queryGbZpccList`
export const queryPhotoPercentNeed = (...args) => {
  return post(queryPhotoPercentNeedUrl, ...args)
}

export const queryFamilyListUrl = `${BASE_API_URL}/zs/zd/queryGbJtcyList`
export const queryFamilyList = (...args) => {
  return post(queryFamilyListUrl, ...args)
}

export const queryFamily2ListUrl = `${BASE_API_URL}/zs/zd/queryGbJtcy2List`
export const queryFamily2List = (...args) => {
  return post(queryFamily2ListUrl, ...args)
}

export const queryPolicyListUrl = `${BASE_API_URL}/zs/zd/queryGbZzmmList`
export const queryPolicyList = (...args) => {
  return post(queryPolicyListUrl, ...args)
}

// 存放临时文件
export const uploadTempFileUrl = `${BASE_API_URL}/dz/common/uploadDzLsFile`
export const uploadTempFile = (...args) => {
  return post(uploadTempFileUrl, ...args)
}

// 招生类别
export const queryEnrollStudentCategoriesUrl = `${BASE_API_URL}/zs/zd/queryXbZslbList`
export const queryEnrollStudentCategories = (...args) => {
  return post(queryEnrollStudentCategoriesUrl, ...args)
}

// 招生省份
export const queryGlobalProvinceUrl = `${BASE_API_URL}/zs/zd/queryGbZssfList`
export const queryGlobalProvince = (...args) => {
  return post(queryGlobalProvinceUrl, ...args)
}

export const queryGlobalProvinceNotLimitUrl = `${BASE_API_URL}/zs/zd/queryGbNoLimitZssfList`
export const queryGlobalProvinceNotLimit = (...args) => {
  return post(queryGlobalProvinceNotLimitUrl, ...args)
}

// 校标专业
export const querySchoolMajorUrl = `${BASE_API_URL}/zs/zd/queryXbZyList`
export const querySchoolMajor = (...args) => {
  return post(querySchoolMajorUrl, ...args)
}

// 特殊考生类别
export const querySpecialStudentTypeUrl = `${BASE_API_URL}/zs/zd/queryXbTskslxList`
export const querySpecialStudentType = (...args) => {
  return post(querySpecialStudentTypeUrl, ...args)
}

// 特殊资格申请理由类别
export const querySpecialApplyReasonTypeUrl = `${BASE_API_URL}/zs/zd/queryXbTszgsqlbList`
export const querySpecialApplyReasonType = (...args) => {
  return post(querySpecialApplyReasonTypeUrl, ...args)
}

// 免试申请理由类别
export const queryNoExamApplyReasonTypeUrl = `${BASE_API_URL}/zs/zd/queryXbMssqlbList`
export const queryNoExamApplyReasonType = (...args) => {
  return post(queryNoExamApplyReasonTypeUrl, ...args)
}

// 政策加分申请理由类别
export const queryPolicyApplyReasonTypeUrl = `${BASE_API_URL}/zs/zd/queryXbZcjfsqlbList`
export const queryPolicyApplyReasonType = (...args) => {
  return post(queryPolicyApplyReasonTypeUrl, ...args)
}

// 报考条件
export const queryGlobalEnrollConditionUrl = `${BASE_API_URL}/zs/zd/queryGbBktjList`
export const queryGlobalEnrollCondition = (...args) => {
  return post(queryGlobalEnrollConditionUrl, ...args)
}

export const queryConditionTypeUrl = `${BASE_API_URL}/zs/zd/queryGbBktjXzlxList`
export const queryConditionType = (...args) => {
  return post(queryConditionTypeUrl, ...args)
}

export const queryConditionDataTypeUrl = `${BASE_API_URL}/zs/zd/queryGbBktjSzlxList`
export const queryConditionDataType = (...args) => {
  return post(queryConditionDataTypeUrl, ...args)
}

export const querySexListUrl = `${BASE_API_URL}/zs/zd/queryGbXbList`
export const querySexList = (...args) => {
  return post(querySexListUrl, ...args)
}

export const queryNationListUrl = `${BASE_API_URL}/zs/zd/queryGbMzList`
export const queryNationList = (...args) => {
  return post(queryNationListUrl, ...args)
}

export const querySchoolStudentTypeUrl = `${BASE_API_URL}/zs/zd/queryXbKslbList`
export const querySchoolStudentType = (...args) => {
  return post(querySchoolStudentTypeUrl, ...args)
}

export const querySchoolGraduationTypeUrl = `${BASE_API_URL}/zs/zd/queryXbBylbList`
export const querySchoolGraduationType = (...args) => {
  return post(querySchoolGraduationTypeUrl, ...args)
}

export const queryGlobalMajorWishListUrl = `${BASE_API_URL}/zs/zd/queryGbZyxhList`
export const queryGlobalMajorWishList = (...args) => {
  return post(queryGlobalMajorWishListUrl, ...args)
}

export const queryGlobalYesOrNoUrl = `${BASE_API_URL}/zs/zd/queryGbSfList`
export const queryGlobalYesOrNo = (...args) => {
  return post(queryGlobalYesOrNoUrl, ...args)
}

export const queryGlobalCheckStatusOtherUrl = `${BASE_API_URL}/zs/zd/queryGbShzt2List`
export const queryGlobalCheckStatusOther = (...args) => {
  return post(queryGlobalCheckStatusOtherUrl, ...args)
}

export const queryBatchSingleEnrollTypeUrl = `${BASE_API_URL}/zs/zd/queryDzPcDzlbList`
export const queryBatchSingleEnrollType = (...args) => {
  return post(queryBatchSingleEnrollTypeUrl, ...args)
}

export const queryGlobalCheckStatusUrl = `${BASE_API_URL}/zs/zd/queryGbShjgList`
export const queryGlobalCheckStatus = (...args) => {
  return post(queryGlobalCheckStatusUrl, ...args)
}

export const queryGlobalEnrollPlanUrl = `${BASE_API_URL}/zs/zd/queryDzZsjhList`
export const queryGlobalEnrollPlan = (...args) => {
  return post(queryGlobalEnrollPlanUrl, ...args)
}

export const queryGlobalMultiEnrollPlanUrl = `${BASE_API_URL}/zs/zd/queryDzZsjhList2`
export const queryGlobalMultiEnrollPlan = (...args) => {
  return post(queryGlobalMultiEnrollPlanUrl, ...args)
}

export const queryExtendsFieldDictListUrl = `${BASE_API_URL}/zs/zd/queryTzzdList`
export const queryExtendsFieldDictList = (...args) => {
  return post(queryExtendsFieldDictListUrl, ...args)
}

export const queryEnrollTypeBatchUrl = `${BASE_API_URL}/zs/zd/queryDzPcList`
export const queryEnrollTypeBatch = (...args) => {
  return post(queryEnrollTypeBatchUrl, ...args)
}

export const queryEnrollSpecialTypeListUrl = `${BASE_API_URL}/zs/zd/queryGbTssqlxList`
export const queryEnrollSpecialTypeList = (...args) => {
  return post(queryEnrollSpecialTypeListUrl, ...args)
}

export const queryPayMethodUrl = `${BASE_API_URL}/zs/zd/queryPayTypeList`
export const queryPayMethod = (...args) => {
  return post(queryPayMethodUrl, ...args)
}

export const queryPrepareEnrollCategoryListUrl = `${BASE_API_URL}/zs/zd/queryYkPcZslbList`
export const queryPrepareEnrollCategoryList = (...args) => {
  return post(queryPrepareEnrollCategoryListUrl, ...args)
}

export const queryZybgZyListUrl = `${BASE_API_URL}/zybg/queryZyList`
export const queryZybgZyList = (...args) => {
  return post(queryZybgZyListUrl, ...args)
}

export const saveHandWritingUrl = `${BASE_API_URL}/xshy/saveHandWriting`
export const saveHandWriting = (...args) => {
  return post(saveHandWritingUrl, ...args)
}

export const queryFaceIdHyztdmUrl = `${BASE_API_URL}/xshy/queryFaceIdHyztdm`
export const queryFaceIdHyztdm = (...args) => {
  return post(queryFaceIdHyztdmUrl, ...args)
}
